import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Observable } from "rxjs";
import { AuthenticationService } from "@/_services";
import { MenuService } from "@/_services/menu.service";
import { MenuSection } from "@/_models/menu-item";

@Component({
    selector: "app-mobile-full-menu",
    templateUrl: "./mobile-full-menu.component.html",
    styleUrls: ["./mobile-full-menu.component.scss"],
})
export class MobileFullMenuComponent implements OnInit {
    mainMenu$: Observable<MenuSection>;
    @Output() menuItemClickled: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private menuService: MenuService,
        private authService: AuthenticationService,
    ) {}

    ngOnInit() {
        this.mainMenu$ = this.menuService.createMobileSettingsMenu();
    }

    logout() {
        this.authService.logout().subscribe();
    }
}
